<template>
  <div
    v-if="product"
    class="product-shop-the-look-tile"
  >
    <ProductToggleWishlist
      class="product-shop-the-look-tile__wishlist-toggle button button--secondary button--icon-only"
      :product="product"
    />
    <AppLink
      :to="product.url"
      class="product-shop-the-look-tile__link"
    >
      <div class="product-shop-the-look-tile__image-container">
        <img
          :src="product.image"
          :alt="product.name"
          class="product-shop-the-look-tile__image"
        >
      </div>
      <div class="product-shop-the-look-tile__content">
        <span class="product-shop-the-look-tile__button button button--secondary">{{ $t('Put this look together') }}</span>
      </div>
    </AppLink>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  product?: object
}>()
</script>

<style>
  @import url("~layers/app/components/Product/ShopTheLookTile.css");
</style>
